import { useRouter } from "next/router";
import { useCallback } from "react";

import { LINKS } from "@/constants/links";
import useGlobalState from "@/hooks/useGlobalState";

const useGoBack = (): ((pathsToAvoid?: string[]) => void) => {
  const { previousPath } = useGlobalState();
  const router = useRouter();

  const goBack = useCallback(
    (pathsToAvoid: string[] = ["/login/sms", "/login/verify"]) => {
      // Go home if no previous path
      if (!previousPath) return router.push("/");
      if (pathsToAvoid && pathsToAvoid.includes(previousPath)) {
        return router.push("/");
      }
      if (previousPath === LINKS.SHOP) {
        return router.push(previousPath);
      }

      router.back();
    },
    [previousPath]
  );

  return goBack;
};

export default useGoBack;
